import { Node, mergeAttributes } from '@tiptap/core'
import { NodeViewWrapper, ReactNodeViewProps, ReactNodeViewRenderer } from '@tiptap/react'

import { Text } from '@/components/ui/Text'

export function PlotEmbedView(props: ReactNodeViewProps) {
  const { node } = props

  const embedId = String(node.attrs.embedId ?? '')

  return (
    <NodeViewWrapper
      as="div"
      className="my-2 flex items-center rounded-md border border-border bg-muted px-3 py-2"
      data-embed-id={embedId}
      data-testid="artifact-md-editor-plot-embed"
    >
      <Text as="span" size="sm" color="muted">
        Plot {embedId}
      </Text>
    </NodeViewWrapper>
  )
}

export const PlotEmbedNode = Node.create({
  name: 'plotEmbed',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      embedId: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-embed-id'),
        renderHTML: (attributes) => {
          return { 'data-embed-id': attributes.embedId }
        },
      },
    }
  },

  parseHTML() {
    return [{ tag: 'div[data-plot-embed]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-plot-embed': '' })]
  },

  addNodeView() {
    return ReactNodeViewRenderer(PlotEmbedView)
  },
})
